export const openx_config = {
    'all': {
        delDomain: 'readtheory-d.openx.net',
    },

    'efe_hp_728': {
        unit: '540803666',
    },

    'efe_topics_160': {
        unit: '540803667',
    },

    'efe_topics_bottom_728': {
        unit: '540803668',
    },

    'efe_topics_mid_728_1': {
        unit: '540803669',
    },
    'efe_topics_mid_728_2': {
        unit: '540803670'
    },
    'efe_topics_mid_728_3': {
        unit: '540803671'
    }

};
